import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '../utils/text';
import CommentedItemPreview from './CommentedItemPreview';

const Comment = ({ comment, onDelete, contentAndImageLinks }) => {
    const fullUrl = `${comment.url}#comment-${comment.id}`;

    const canDelete =
        !comment.is_system_comment &&
        !comment.comment_type &&
        DJ_CONST.user &&
        (DJ_CONST.user.id === comment.user_id || DJ_CONST.user.is_staff);
    const button = canDelete ? (
        <div className="comment__buttons">
            <a href={undefined} onClick={onDelete}>
                <span className="sr-only">{gettext('Delete comment')}</span>
                <i className="icon icon--trash icon-button" />
            </a>
        </div>
    ) : null;

    let commentText = (
        <div
            className={`comment__text ${comment.comment_type ? comment.comment_type : ''}`}
            dangerouslySetInnerHTML={{
                __html: comment.comment_html,
            }}
        />
    );
    if (contentAndImageLinks) {
        commentText = (
            <div>
                <a href={fullUrl}>{commentText}</a>
                <a href={fullUrl} className="link">
                    {gettext('Read more')}
                </a>
            </div>
        );
    }

    let commentAttachment = null;
    if (comment.attachment_url) {
        commentAttachment = (
            <div className="comment__attachment">
                <div>Attachment:</div>
                <a href={comment.attachment_url}>{comment.attachment_name}</a>
            </div>
        );
    }

    return (
        <div id={`comment-${comment.id}`} key={comment.id} className="comment">
            {comment.preview ? (
                <CommentedItemPreview preview={comment.preview} href={contentAndImageLinks ? fullUrl : null} />
            ) : null}
            <div className="comment__content">
                {comment.is_system_comment ? (
                    <div className="comment__author">
                        <a className="comment__author__avatar" href={comment.member_permalink}>
                            <span className="comment__system__avatar"></span>
                        </a>
                        <div className="comment__meta">
                            {button}
                            <a className="comment__author__name" href={comment.member_permalink}>
                                Trafo.no
                            </a>
                            <div className="comment__author__time">
                                <a href={fullUrl}>
                                    <time title={comment.created_at}>{comment.created_at_natural}</time>
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="comment__author">
                        <a className="comment__author__avatar" href={comment.member_permalink}>
                            <img src={comment.user_avatar_url_small} alt={comment.user_full_name} />
                        </a>
                        <div className="comment__meta">
                            {button}
                            <a className="comment__author__name" href={comment.member_permalink}>
                                {comment.user_full_name}
                            </a>
                            <div className="comment__author__time">
                                <a href={fullUrl}>
                                    <time title={comment.created_at}>{comment.created_at_natural}</time>
                                </a>
                            </div>
                            {comment.visibility ? (
                                <div className="subtitle text-muted">{comment.visibility}</div>
                            ) : null}
                            {comment.comment_type === 'mentor-application-report_delivered' ||
                            comment.comment_type === 'funding-application-report_delivered' ? (
                                <div className="subtitle text-muted">{gettext('Final report')}</div>
                            ) : null}
                        </div>
                    </div>
                )}
                {commentText}
                {commentAttachment}
            </div>
        </div>
    );
};

Comment.propTypes = {
    comment: PropTypes.shape({
        id: PropTypes.number.isRequired,
        user_id: PropTypes.number.isRequired,
        comment: PropTypes.string.isRequired,
        comment_type: PropTypes.string,
        user_full_name: PropTypes.string.isRequired,
        member_permalink: PropTypes.string.isRequired,
        user_avatar_url_small: PropTypes.string.isRequired,
        created_at_natural: PropTypes.string.isRequired,
        preview: PropTypes.shape({
            contenttype: PropTypes.string,
        }),
        attachment_url: PropTypes.string,
        attachment_name: PropTypes.string,
        visibility: PropTypes.string,
        is_system_comment: PropTypes.bool,
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    contentAndImageLinks: PropTypes.bool,
};

Comment.defaultProps = {
    preview: undefined,
    contentAndImageLinks: false,
};

export default Comment;



// WEBPACK FOOTER //
// ./src/components/Comment.js